import { Product } from '../types';

// Temporary gate: SMS Homeowner Leads are visible but not yet purchasable while
// the backend is being prepped. Flip to false to enable ordering everywhere.
export const HOMEOWNER_LEADS_COMING_SOON = false;

// Data points / column headers delivered with every SMS Homeowner lead.
// Shown in a collapsible section on each homeowner product page.
export const homeownerLeadFields: string[] = [
  'First Name',
  'Last Name',
  'Phone',
  'Address',
  'City',
  'State',
  'Zip',
  'Email',
  'Date of Birth',
  'Estimated Home Value',
  'Mortgage Balance',
  'Credit Grade',
  'Property Type',
  'Loan Type',
  'Interest Rate',
  'Response',
  'Beneficiary',
  'AI Assistant Name',
];

export const products: Product[] = [
  // Available products first
  {
    id: 5,
    name: 'Volume Internet Quote Leads',
    shortDescription: 'Online survey generated leads',
    description: 'Fresh leads from targeted surveys across demographics. Actively engaged prospects interested in relevant products and services.',
    image: '/image copy.png',
    category: 'Survey Leads',
    pricing: {
      perLead: 0.50,
      packages: [
        { quantity: 200, price: 100 },
        { quantity: 500, price: 250 },
        { quantity: 1000, price: 500 }
      ]
    }
  },
  {
    id: 7,
    name: 'Enhance Dialer Seat V.1',
    shortDescription: 'Budget-friendly dialer for new agents',
    description: '90-120 day aged surveys with dialer license included. Budget friendly option perfect for new agents getting started.',
    image: '/image copy copy.png',
    category: 'Dialer Technology',
    pricing: {
      perLead: 500,
      packages: [
        { quantity: 1, price: 500 }
      ]
    }
  },
  {
    id: 16,
    name: 'Enhance Dialer Seat V.2',
    shortDescription: 'Premium dialer for amateur agents',
    description: '30 day aged surveys with Fresh IQ Leads and dialer license included. Budget friendly option perfect for amateur agents.',
    image: '/image copy copy.png',
    category: 'Dialer Technology',
    pricing: {
      perLead: 1000,
      packages: [
        { quantity: 1, price: 1000 }
      ]
    }
  },
  {
    id: 17,
    name: 'Enhance Dialer Seat V.3- IUL LEADS',
    shortDescription: 'Advanced dialer with unlimited IUL leads',
    description: 'Unlimited IUL leads for 1 week with dialer license included. Great for advanced clients looking to put money aside for retirement and death benefit.',
    image: '/image copy copy.png',
    category: 'Dialer Technology',
    pricing: {
      perLead: 500,
      packages: [
        { quantity: 1, price: 500 }
      ]
    }
  },
  {
    id: 19,
    name: 'Enhance Dialer Seat V.4- Missed Inbound',
    shortDescription: 'Dialer with missed inbound leads',
    description: 'Missed inbound leads delivered straight to your dialer. These are people who called in for life insurance but were never helped. Warm, high-intent prospects ready for immediate contact. Dialer license included.',
    image: '/image copy copy.png',
    category: 'Dialer Technology',
    pricing: {
      perLead: 1000,
      packages: [
        { quantity: 1, price: 1000 }
      ]
    }
  },
  {
    id: 8,
    name: 'Enhance IUL Leads',
    shortDescription: 'Indexed Universal Life insurance leads',
    description: 'Fresh IUL leads from qualified prospects actively seeking Indexed Universal Life insurance solutions. Perfect for insurance agents specializing in IUL products.',
    image: '/product-photos/image.png',
    category: 'Insurance Leads',
    pricing: {
      perLead: 36,
      packages: [
        { quantity: 20, price: 720 },
        { quantity: 30, price: 1080 },
        { quantity: 50, price: 1800 }
      ]
    }
  },
  {
    id: 23,
    name: 'Missed Inbound Leads 0-10 Day',
    shortDescription: 'Recent missed inbound callers within 0-10 days',
    description: 'Fresh missed inbound leads from the last 0-10 days. These are people who recently called in for life insurance but were never helped. Ultra-fresh leads with the highest conversion potential.',
    image: '/product-photos/image.png',
    category: 'Inbound Leads',
    pricing: {
      perLead: 0.50,
      packages: [
        { quantity: 1000, price: 500 },
        { quantity: 3000, price: 1500 },
        { quantity: 5000, price: 2500 }
      ]
    }
  },
  // Sold out products at the end
  {
    id: 1,
    name: 'Enhance Fresh Mortgage Protection Leads',
    shortDescription: 'High-quality mortgage protection leads',
    description: 'Fresh, verified mortgage protection leads from homeowners actively seeking coverage. Perfect for insurance agents and financial advisors.',
    image: '/product-photos/image copy.png',
    category: 'Insurance Leads',
    soldOut: true,
    pricing: {
      perLead: 28,
      packages: [
        { quantity: 20, price: 560 },
        { quantity: 30, price: 840 },
        { quantity: 50, price: 1400 }
      ]
    }
  },
  {
    id: 3,
    name: 'Enhance Fresh Veteran Leads',
    shortDescription: 'Military veteran targeted leads',
    description: 'Exclusive leads from veterans and families seeking veteran benefits and services. Perfect for VA loan officers and veteran organizations.',
    image: '/product-photos/image.png',
    category: 'Veteran Services',
    soldOut: true,
    pricing: {
      perLead: 32,
      packages: [
        { quantity: 20, price: 640 },
        { quantity: 30, price: 960 },
        { quantity: 50, price: 1600 }
      ]
    }
  },
  {
    id: 4,
    name: 'Enhance Fresh Trucker Leads',
    shortDescription: 'Commercial trucking industry leads',
    description: 'High-converting leads from truckers seeking insurance, financing, and equipment. Ideal for commercial agents and trucking service providers.',
    image: '/image.png',
    category: 'Commercial Leads',
    soldOut: true,
    pricing: {
      perLead: 36,
      packages: [
        { quantity: 20, price: 720 },
        { quantity: 30, price: 1080 },
        { quantity: 50, price: 1800 }
      ]
    }
  }
];

export const agedProducts: Product[] = [
  {
    id: 9,
    name: 'Aged Trucker Leads',
    shortDescription: 'Cost-effective aged trucking leads',
    description: 'Aged leads from truck drivers and trucking companies who have previously shown interest in trucking-related services. Ideal for commercial insurance agents seeking cost-effective trucking industry leads.',
    image: '/product-photos/image copy copy copy.png',
    category: 'Aged Commercial Leads',
    pricing: {
      perLead: 6,
      packages: [
        { quantity: 50, price: 300 },
        { quantity: 100, price: 600 }
      ]
    }
  },
  {
    id: 10,
    name: 'Aged Veteran Leads',
    shortDescription: 'Cost-effective aged veteran leads',
    description: 'Aged leads from military veterans and their families who have shown interest in veteran-specific benefits and services. Perfect for VA loan officers and veteran service organizations looking for budget-friendly options.',
    image: '/product-photos/image copy copy.png',
    category: 'Aged Veteran Services',
    pricing: {
      perLead: 3,
      packages: [
        { quantity: 50, price: 150 },
        { quantity: 100, price: 300 }
      ]
    }
  },
  {
    id: 13,
    name: 'Aged IUL Leads',
    shortDescription: 'Cost-effective aged IUL leads',
    description: 'Aged IUL leads from qualified prospects who have previously shown interest in Indexed Universal Life insurance solutions. Perfect for insurance agents specializing in IUL products seeking budget-friendly options.',
    image: '/product-photos/image.png',
    category: 'Aged Insurance Leads',
    pricing: {
      perLead: 3,
      packages: [
        { quantity: 50, price: 150 },
        { quantity: 100, price: 300 }
      ]
    }
  },
  {
    id: 24,
    name: 'Missed Inbound Leads 10+ Day',
    shortDescription: 'Missed inbound callers aged 10+ days',
    description: 'Missed inbound leads aged 10+ days. These are people who called in for life insurance, were never helped, and have since re-confirmed their interest. Great value leads at a lower price point.',
    image: '/product-photos/image.png',
    category: 'Aged Inbound Leads',
    pricing: {
      perLead: 0.40,
      packages: [
        { quantity: 1000, price: 400 },
        { quantity: 3000, price: 1200 },
        { quantity: 5000, price: 2000 }
      ]
    }
  }
];

export const smsProducts: Product[] = [
  {
    id: 28,
    name: 'SMS-LIFE Bundle of 50',
    shortDescription: 'A.I. fresh SMS life insurance leads: 50 lead bundle',
    description: 'Every SMS Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy copy copy.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 5,
      packages: [
        { quantity: 50, price: 250 }
      ]
    }
  },
  {
    id: 29,
    name: 'SMS-LIFE Bundle of 100',
    shortDescription: 'A.I. fresh SMS life insurance leads: 100 lead bundle',
    description: 'Every SMS Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy copy.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 5,
      packages: [
        { quantity: 100, price: 500 }
      ]
    }
  },
  {
    id: 30,
    name: 'SMS-LIFE Bundle of 200',
    shortDescription: 'A.I. fresh SMS life insurance leads: 200 lead bundle',
    description: 'Every SMS Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 5,
      packages: [
        { quantity: 200, price: 1000 }
      ]
    }
  },
  {
    id: 31,
    name: 'SMS-LIFE Bundle of 400',
    shortDescription: 'A.I. fresh SMS life insurance leads: 400 lead bundle',
    description: 'Every SMS Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 5,
      packages: [
        { quantity: 400, price: 2000 }
      ]
    }
  },
  {
    id: 25,
    name: 'SMS-LIFE w/ Beneficiary (25 Leads)',
    shortDescription: 'Starter pack: 25 SMS-confirmed life insurance leads with beneficiary info',
    description: 'Premium life insurance leads who have confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 15,
      packages: [
        { quantity: 25, price: 375 }
      ]
    }
  },
  {
    id: 26,
    name: 'SMS-LIFE w/ Beneficiary (50 Leads)',
    shortDescription: 'Most popular: 50 SMS-confirmed life insurance leads with beneficiary info',
    description: 'Premium life insurance leads who have confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 15,
      packages: [
        { quantity: 50, price: 750 }
      ]
    }
  },
  {
    id: 27,
    name: 'SMS-LIFE w/ Beneficiary (100 Leads)',
    shortDescription: 'Volume pack: 100 SMS-confirmed life insurance leads with beneficiary info',
    description: 'Premium life insurance leads who have confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 15,
      packages: [
        { quantity: 100, price: 1500 }
      ]
    }
  }
];

// Aged A.I. SMS positive-response life leads (3-15 days old). No heads-up
// template / rep name+number, no replacements. Restricted state set.
export const smsPositiveProducts: Product[] = [
  {
    id: 39,
    name: 'A.I. SMS Positive Responses',
    shortDescription: 'Aged SMS positive-response life leads (3-15 days)',
    description: 'Leads that positively responded to our request to offer life insurance quotes. Lead freshness can range from 3 to 15 days from the initial message.',
    image: '/product-photos/image.png',
    category: 'SMS Leads',
    pricing: {
      perLead: 1,
      packages: [
        { quantity: 100, price: 100 },
        { quantity: 200, price: 200 },
        { quantity: 300, price: 300 }
      ]
    }
  }
];

export const smsHomeownerProducts: Product[] = [
  // ===== Beneficiary Only ($18/lead) =====
  {
    id: 32,
    name: 'SMS-LIFE Homeowners w/ Beneficiary (25 Leads)',
    shortDescription: 'Starter pack: 25 SMS-confirmed homeowner life leads with beneficiary info',
    description: 'Premium homeowner life insurance leads who confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 18,
      packages: [
        { quantity: 25, price: 450 }
      ]
    }
  },
  {
    id: 33,
    name: 'SMS-LIFE Homeowners w/ Beneficiary (50 Leads)',
    shortDescription: 'Most popular: 50 SMS-confirmed homeowner life leads with beneficiary info',
    description: 'Premium homeowner life insurance leads who confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 18,
      packages: [
        { quantity: 50, price: 900 }
      ]
    }
  },
  {
    id: 34,
    name: 'SMS-LIFE Homeowners w/ Beneficiary (100 Leads)',
    shortDescription: 'Volume pack: 100 SMS-confirmed homeowner life leads with beneficiary info',
    description: 'Premium homeowner life insurance leads who confirmed their interest via SMS, including full beneficiary information. Each lead includes the exact message the lead responded with, the initiated question that was asked, and complete beneficiary details for higher conversion rates. Includes a pre-call heads-up SMS to each lead using a template you choose at checkout.',
    image: '/product-photos/image.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 18,
      packages: [
        { quantity: 100, price: 1800 }
      ]
    }
  },
  // ===== Bundles ($6/lead) =====
  {
    id: 35,
    name: 'SMS-LIFE Homeowner Bundle of 50',
    shortDescription: 'A.I. fresh SMS homeowner life leads: 50 lead bundle',
    description: 'Every SMS Homeowner Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy copy copy.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 6,
      packages: [
        { quantity: 50, price: 300 }
      ]
    }
  },
  {
    id: 36,
    name: 'SMS-LIFE Homeowner Bundle of 100',
    shortDescription: 'A.I. fresh SMS homeowner life leads: 100 lead bundle',
    description: 'Every SMS Homeowner Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy copy.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 6,
      packages: [
        { quantity: 100, price: 600 }
      ]
    }
  },
  {
    id: 37,
    name: 'SMS-LIFE Homeowner Bundle of 200',
    shortDescription: 'A.I. fresh SMS homeowner life leads: 200 lead bundle',
    description: 'Every SMS Homeowner Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image copy.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 6,
      packages: [
        { quantity: 200, price: 1200 }
      ]
    }
  },
  {
    id: 38,
    name: 'SMS-LIFE Homeowner Bundle of 400',
    shortDescription: 'A.I. fresh SMS homeowner life leads: 400 lead bundle',
    description: 'Every SMS Homeowner Lead is sourced exclusively from our own networks and filtered through a custom A.I. qualification flow, so by the time it reaches you, it\'s already been engaged, screened, and verified.',
    image: '/product-photos/image.png',
    category: 'SMS Homeowner Leads',
    pricing: {
      perLead: 6,
      packages: [
        { quantity: 400, price: 2400 }
      ]
    }
  }
];
